import { useCallback } from "react";
import ReactGA from "react-ga4";

const IS_PRODUCTION =
  process.env.NODE_ENV === "production" &&
  typeof window !== "undefined" &&
  window.location.hostname !== "localhost" &&
  window.location.hostname !== "127.0.0.1";

const send = (eventName, params = {}) => {
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) =>
        value !== undefined &&
        value !== null &&
        value !== ""
    )
  );

  if (IS_PRODUCTION) {
    ReactGA.event(eventName, cleanParams);
    return;
  }

  console.group(
    `%c[YogGoalAnalytics] ${eventName}`,
    "color:#3d6b4f;font-weight:bold;"
  );
  if (Object.keys(cleanParams).length) {
    console.table(cleanParams);
  } else {
    console.log("(no params)");
  }
  console.groupEnd();
};

const useYogGoalAnalytics = () => {
  const trackPageView = useCallback((goalName, url) => {
    send("yog_goal_page_view", {
      goal_name: goalName,
      page_location: url,
    });
  }, []);

  const trackVideoSelect = useCallback(
    (video, goalName, source = "card") => {
      send("yog_goal_video_select", {
        goal_name: goalName,
        video_id: video?.videoId,
        video_name: video?.name,
        video_duration: video?.duration,
        source,
      });
    },
    []
  );

  const trackVideoPlay = useCallback(
    (video, goalName) => {
      send("yog_goal_video_play", {
        goal_name: goalName,
        video_id: video?.videoId,
        video_name: video?.name,
        video_duration: video?.duration,
      });
    },
    []
  );

  return {
    trackPageView,
    trackVideoSelect,
    trackVideoPlay,
  };
};

export default useYogGoalAnalytics;
